import { randRecentDate } from '@ngneat/falso';
import { MockPath, MockPagination } from '@library/common/http/mock-path.mock';

import { randomArray, optional } from '@library/common/functions';

import { mockUser } from '@library/modules/user/user.routes.mock';

import { MockBulkQueue } from './bulk-queue/bulk-queue.mock';
import { MockCartageDetail } from './models/mock/cartage-detail.mock';
import { MockCartageListItem } from './models/mock/cartage-list-item.mock';

/* Order matters for the routes, first match is returned, match is RegExp based */
export const CartageRoutes: MockPath<unknown>[] = [
   { path: 'routing/bulkqueue/archive', verb: 'POST', response: opts => ({
      collection: randomArray( MockBulkQueue ).map( item => ({
         ...item,
         user: optional( 70 ) ? item.user : `${mockUser.fname} ${mockUser.lname}`,
         uploaded: randRecentDate({ days: 10 }),
      })),
      pagination: MockPagination( opts?.body?.pagination )
   })},
   { path: 'routing/bulkqueue/.*', verb: 'GET', collection: () => [ new MockBulkQueue() ]},
   { path: 'routing/bulkqueue', verb: 'GET', collection: () => randomArray( MockBulkQueue ).map( item => ({
      ...item,
      user: optional() ? item.user : `${mockUser.fname} ${mockUser.lname}`,
   }))},

   { path: 'routing/update', verb: 'POST', collection: () => [] },

   { path: 'routing.*', verb: 'GET', collection: () => [ new MockCartageDetail() ]},
   { path: 'routing', verb: 'GET', collection: () => randomArray( MockCartageListItem, 100 )},

   { path: 'routing/list', verb: 'POST', response: opts => ({
      collection: optional( 85 ) ? randomArray( MockCartageListItem, 100 ) : [],
      pagination: MockPagination( opts?.body?.pagination ),
   })},

   { path: 'enum/status_types/(.*)', verb: 'GET', collection: opts => {
      switch ( opts.captured[0] ) {
         case 'pickup':
            return [
              { "code": "pConfirmed", "label": "Pickup Alert Confirmed" },
              { "code": "pTendered", "label": "Tendered to Carrier" },
              { "code": "pPOD", "label": "Proof of Delivery" },
            ];
         case 'delivery':
            return [
               { "code": "dOut", "label": "Out for Delivery" },
               { "code": "dPOD", "label": "Proof of Delivery" },
               { "code": "dArrivedDestination", "label": "Arrival at Carrier Destination Facility" },
            ];
         case 'linehaul':
            return [
               { "code": "lPickedUp", "label": "Pick up" },
               { "code": "lReWeigh", "label": "Re-Weigh" },
               { "code": "larrivedDestination", "label": "Arrival at Destination" },
            ];
      }
   }},
];
